export default __webpack_public_path__ + "static/media/info-item9.6460de56.svg";